<template lang="pug">
span.root
	.filters
		template(v-for="filter in filters")
			.filters__checkboxes
				p.filters__checkboxes-title Filter by {{ filter.name }}
				template(v-for="item in filter.filters")
					FilterCheckbox(
						:data="item",
						:setFilterValue="setFilterValue"
					)
		button.btn.filters__apply(@click="executeSearch(); $emit('search')") Apply

</template>

<script>
import FilterCheckbox from "./Filter.vue";

export default {
	name: "CaroFilters",
	components: {
		FilterCheckbox,
	},
	props: {
		filters: Array,
		results: Object,
		setFilterValue: Function,
		executeSearch: Function,
	},
};
</script>


<style lang="scss" scoped>
span.root {
	display: contents;
}
.filters {
	&__checkboxes {
		border-top: 1px solid #E1E1E1;
		padding: 1.875rem 0 .5rem 0;
		&-title {
			color: #103846;
			font-weight: 500;
			text-transform: uppercase;
			margin-bottom: 1.5rem;
		}
	}
	&__apply {
		width: 100%;
	}
}
//.input {
//	&__select {
//		position: relative;
//		width: 100%;
//		height: 3rem;
//		margin: 0 0 1rem 0;
//		border: 1px solid var(--border-color);
//		display: flex;
//		align-items: center;
//		border-radius: .25rem;
//
//		&::after {
//			content: "";
//			position: absolute;
//			top: 50%;
//			right: 1.25rem;
//			height: 0.5rem;
//			width: 0.5rem;
//			border-left: 2px solid;
//			border-bottom: 2px solid;
//			transform: translate(50%, -75%) rotate(-45deg);
//		}
//
//		select {
//			@include clean(input);
//			width: 100%;
//			cursor: pointer;
//			padding: 1rem 2.5rem 1rem 1rem;
//		}
//	}
//}
////.input__select,
//.input__text {
//	margin-bottom: 1rem;
//	width: 100%;
//}
//
////.input__select,
//.input__text {
//	border-radius: .25rem;
//	height: 3rem;
//	margin: 0 0 1rem 0;
//	border: 1px solid var(--border-color);
//	padding: 0 1rem;
//}
//.input__label {
//	color: #646566;
//	display: block;
//	margin-bottom: .25rem;
//}
//.filters__checkboxes {
//	margin-bottom: 1.25rem;
//	&-title {
//		color: #646566;
//		margin-bottom: .5rem;
//		font-weight: 400;
//	}
//}
//.filters__apply {
//	width: 100%;
//	color: $white !important;
//
//}
//.filters__header {
//	display: flex;
//	justify-content: space-between;
//	padding-bottom: .5rem;
//	margin-bottom: .5rem;
//	//border-bottom: 1px solid $borderColor;
//
//	p {
//		margin: 0;
//		font-size: .75rem;
//		font-weight: 700;
//		transition: ease .35s;
//		&:last-of-type {
//			color: #ACAEAF;
//			cursor: pointer;
//			&:hover {
//				//color: $darkImperialBlue
//			}
//		}
//	}
//}
</style>
